import React from "react";
import PropTypes from "prop-types";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import NewsData from "../data/news.json";
import NewsItemContainer from "../containers/news/news-item";
import { slugify } from "../utils";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const NewsDate = ({
    match: {
        params: { date },
    },
}) => {
    const data = NewsData.filter((news) => slugify(news.date) === date);
    const dateTitle = data[0].date;
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title={
                        dateTitle +
                        " News | NeoGrowth - Lending simplified. Growth amplified."
                    }
                />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title={dateTitle}
                        excerpt=""
                        image="/images/banner/page/news.png"
                    />
                    <NewsItemContainer data={data} />
                    {/* <NewsletterArea /> */}
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

NewsDate.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            date: PropTypes.string,
        }),
    }),
};

export default NewsDate;
